import { fetchRecommendedGames } from '@/lib/aggregation';
import type { Game } from '@/types/games';
import type { GameViewModel } from '@/types/games/game-view-model';
import { adaptGame } from '@/logic/game-adapter/adapt-game';

type RecommendedGamesApiResponse = {
    pageConfig?: {
        content?: {
            results?: Game[];
        };
    };
};

const parseRecommendedGamesResponse = (response: RecommendedGamesApiResponse | null | undefined): Game[] =>
    response?.pageConfig?.content?.results ?? [];

export const getRecommendedGames = async (): Promise<GameViewModel[]> => {
    const response = (await fetchRecommendedGames()) as RecommendedGamesApiResponse | null;
    const rawGames = parseRecommendedGamesResponse(response);

    return rawGames.map((game) => adaptGame(game, { disableAnimatedTiles: true }));
};
